var _style, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.5 92.5",
    style: {
      enableBackground: "new 0 0 92.5 92.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000003795784507942508770000000932303814062465923_);}\n\t.st2{fill:url(#SVGID_00000002349613107739129420000010309212069915962542_);}\n\t.st3{fill:url(#SVGID_00000169544796082503284890000006705135434468482719_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3492,
    y1: 31.2582,
    x2: 30.1835,
    y2: 61.4294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76489C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2077,
    style: {
      stopColor: "#432B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8128,
    style: {
      stopColor: "#5A51A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#5E57A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9463,
    style: {
      stopColor: "#6A68AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7578B8"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46,
    cy: 46.1,
    r: 43.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103980353506321849170000013919897683812902563_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.6827,
    y1: 5.7609,
    x2: 69.0459,
    y2: 86.0048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76489C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872,
    style: {
      stopColor: "#432B7C"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000103980353506321849170000013919897683812902563_)"
    },
    cx: 46,
    cy: 46.1,
    r: 41.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082367125265112899660000003136159423968351384_",
    gradientUnits: "userSpaceOnUse",
    x1: 46,
    y1: 20.2748,
    x2: 46,
    y2: 72.5067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000082367125265112899660000003136159423968351384_)"
    },
    cx: 46,
    cy: 30.8,
    r: 11.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094619017116256701540000010890095816695781565_",
    gradientUnits: "userSpaceOnUse",
    x1: 46,
    y1: 20.2748,
    x2: 46,
    y2: 72.5069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094619017116256701540000010890095816695781565_)"
    },
    d: "M46,46.4c-9.3,0-17.5,4.9-22.1,12.2 c-3.8,6.1,0.6,14,7.8,14h28.6c7.2,0,11.7-7.9,7.8-14C63.5,51.2,55.3,46.4,46,46.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondPro);
export default __webpack_public_path__ + "static/media/second-pro.65913182d4e8b8e20b32db618418e3ea.svg";
export { ForwardRef as ReactComponent };